<template>
  <div class="con1">
    <div class="container">
      <div class="logo">
        <img src="@/assets/img/aitutorplus/con1/logo.png" alt="img" />
      </div>
      <div class="content">
        <div class="text-content">
          <p class="text">마이 랭귀지 튜터</p>
          <img
            src="@/assets/img/aitutorplus/con1/text1-m.png"
            alt=""
            class="text1-m"
          />
          <img
            src="@/assets/img/aitutorplus/con1/text1-pc.png"
            alt=""
            class="text1-pc"
          />
          <div class="go-down" @click="downApp">
            <p>말랑톡 엿보기</p>
            <img src="@/assets/img/aitutorplus/con1/go.png" alt="img" />
          </div>
        </div>
        <div class="video-content">
          <div class="video-area">
            <div class="box"></div>
            <video
              muted
              autoplay
              playsinline
              loop
              poster="@/assets/img/aitutorplus/con1/poster-m.png"
              src="@/assets/img/aitutorplus/con1/video-m.mp4"
              class="video-m"
            ></video>
            <video
              muted
              autoplay
              playsinline
              loop
              poster="@/assets/img/aitutorplus/con1/poster-pc.png"
              src="@/assets/img/aitutorplus/con1/video-pc.mp4"
              class="video-pc"
            ></video>
          </div>
          <img src="@/assets/img/aitutorplus/con1/frame.png" alt="img" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    downApp() {
      // 사용자의 운영 체제 확인
      const isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
      const isWindows = navigator.platform.toUpperCase().indexOf("WIN") >= 0;
      const isAndroid = /Android/.test(navigator.userAgent);

      // 웹사이트 URL 설정
      let websiteURL = "";
      if (isMac || isIOS) {
        websiteURL = "https://apps.apple.com/kr/app/ai-tutor-plus/id6471957039";
      } else if (isWindows || isAndroid) {
        websiteURL =
          "https://play.google.com/store/apps/details?id=com.carrot.solutions.aitutor&hl=ko-KR";
      }

      // 새 창에서 열기
      if (websiteURL) {
        window.open(websiteURL, "_blank");
      }
    },

    goMalang() {
      window.open("https://www.imooc.co.kr/link/65e95cb640bc385730", "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
img,
video {
  display: block;
  width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;

  @media screen and (min-width: 1200px) {
    padding: 0;
  }
}

.br-m {
  @media screen and (min-width: 1200px) {
    display: none;
  }
}

.con1 {
  position: relative;
  padding-top: 14px;
  background: linear-gradient(
    300deg,
    rgba(79, 70, 229, 1) 0%,
    rgba(139, 92, 246, 1) 100%
  );
  overflow: hidden;

  &::before {
    content: "";
    background-image: url(~@/assets/img/aitutorplus/con1/bg-m-left.png),
      url(~@/assets/img/aitutorplus/con1/bg-m-right.png);
    background-size: 248px 500px, 248px 202px;
    background-repeat: no-repeat;
    background-position: left bottom, right top;
    background-blend-mode: luminosity;
    position: absolute;
    inset: 0;

    @media screen and (min-width: 1200px) {
      background-image: url(~@/assets/img/aitutorplus/con1/bg-pc-left.png),
        url(~@/assets/img/aitutorplus/con1/bg-pc-right.png);
      background-size: 576px 954px, 528px 324px;
      opacity: 0.5;
    }
  }

  @media screen and (min-width: 1200px) {
    padding-top: 28px;
  }

  .container {
    position: relative;
    z-index: 1;

    .logo {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 70px;

      @media screen and (min-width: 1200px) {
        margin-bottom: 126px;
      }

      img {
        width: 86px;

        @media screen and (min-width: 1200px) {
          width: 132px;
        }
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      gap: 54px;

      @media screen and (min-width: 1200px) {
        flex-direction: row;
        justify-content: space-between;
      }

      .text-content {
        display: flex;
        flex-direction: column;
        align-items: center;

        @media screen and (min-width: 1200px) {
          align-items: flex-start;
          padding-top: 90px;
        }

        .text {
          position: relative;
          right: 20px;
          font-size: 20px;
          color: #fff;
          margin-bottom: 10px;

          @media screen and (min-width: 1200px) {
            right: 0;
            left: 50px;
            font-size: 34px;
            margin-bottom: 26px;
          }
        }

        .text1-m {
          width: 268px;
          margin-bottom: 36px;

          @media screen and (min-width: 1200px) {
            display: none;
          }
        }

        .text1-pc {
          display: none;

          @media screen and (min-width: 1200px) {
            display: block;
            width: 568px;
            margin-bottom: 78px;
          }
        }

        .go-down {
          display: flex;
          align-items: center;
          gap: 14px;
          padding: 20px 30px;
          border: 1px solid #fff;
          border-radius: 60px;
          cursor: pointer;

          @media screen and (min-width: 1200px) {
            position: relative;
            left: 28px;
          }

          p {
            font-weight: 700;
            color: #fff;

            @media screen and (min-width: 1200px) {
              font-size: 20px;
            }
          }

          img {
            width: 14px;

            @media screen and (min-width: 1200px) {
              width: 18px;
            }
          }
        }
      }

      .video-content {
        display: flex;
        justify-content: center;
        position: relative;
        width: 234px;
        height: 340px;
        margin: 0 auto;
        border-top-left-radius: 35px;
        border-top-right-radius: 35px;
        box-shadow: 50px 50px 50px rgba($color: #241a5b, $alpha: 0.16);
        overflow: hidden;

        @media screen and (min-width: 1200px) {
          flex: none;
          width: 413px;
          height: 767px;
          margin: 0;
          border-top-left-radius: 68px;
          border-top-right-radius: 68px;
        }

        .video-area {
          position: relative;
          background: #fff;
          padding-top: 6px;

          @media screen and (min-width: 1200px) {
            width: calc(100% - 20px);
            padding-top: 17px;
          }

          .box {
            display: none;

            @media screen and (min-width: 1200px) {
              display: block;
              flex: none;
              width: 100%;
              height: 30px;
              background: #fff;
            }
          }

          video {
            object-fit: cover;

            &.video-m {
              height: 100%;

              @media screen and (min-width: 1200px) {
                display: none;
              }
            }

            &.video-pc {
              display: none;
              @media screen and (min-width: 1200px) {
                display: block;
              }
            }
          }
        }

        img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 1;
        }
      }
    }
  }
}
</style>
